export default {
  city: '西安',
  lat: 34.265725,
  lng: 108.95346
}
